import { render, staticRenderFns } from "./layout-hostadmin.vue?vue&type=template&id=51a2185f"
import script from "./layout-hostadmin.vue?vue&type=script&lang=ts"
export * from "./layout-hostadmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports